import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose Configure one location and everything tied to it: data, repair QR link, enabled request types, budget periods, material stock
 * @primary Location data form
 * @persona paola-admin-belora
 */
export const Route = createFileRoute("/app/c/$customerSlug/locations/$id")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
